<template>
  <tr>
    <td class="w-48 align-text-top"><p class="mr-4">{{ customField.label }}</p></td>
    <td class="text-left align-text-top">
      <!-- Multi-line text -->
      <div v-if="customField.type_id === 2" class="whitespace-pre-line">{{ fieldModel.value }}</div>
      <!-- Single checkbox -->
      <div v-else-if="customField.type_id === 3">
        <input type="checkbox" disabled="disabled" :checked="fieldModel.value" class="mr-1 cursor-default" /> <label></label>
      </div>
      <!-- Multiple checkboxes -->
      <div v-else-if="customField.type_id === 4">
        <span v-for="option in customField.options" :key="option.id" class="mr-4">
          <input type="checkbox" disabled="disabled" :checked="findOptionValue(option.id)" class="mr-1 cursor-default" /> <label>{{ option.name }}</label>
        </span>
      </div>
      <!-- Dropdown -->
      <div v-else-if="customField.type_id === 5">{{ findDropdownValue(fieldModel.value) }}</div>
      <!-- Currency -->
      <div v-else-if="customField.type_id === 6"><span v-if="fieldModel.value">{{ fieldModel.value | gbp }}</span></div>
      <!-- Number -->
      <div v-else-if="customField.type_id === 7"><span v-if="fieldModel.value">{{ fieldModel.value | number }}</span></div>
      <!-- Single line text -->
      <div v-else>{{ fieldModel.value }}</div>
    </td>
  </tr>
</template>

<script>
import { find } from 'lodash'

export default {
  data () {
    return {
    }
  },
  props: ['customField', 'orderItem'],
  computed: {
    fieldModel () {
      return find(this.orderItem.custom_field_values, (field) => (field.custom_field_item_id === this.customField.id))
    }
  },
  methods: {
    findOptionValue (optionId) {
      let optionValue = find(this.fieldModel.value, (optionValue) => (optionValue.id === parseInt(optionId)))

      return optionValue ? optionValue.value === true : false
    },
    findDropdownValue (optionId) {
      let optionValue = find(this.customField.options, (optionValue) => (optionValue.id === parseInt(optionId)))

      return optionValue ? optionValue.name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
table tbody {
  td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0;
    padding-right: 0;
  }
}
input[type=checkbox] {
  &:checked {
    + label {
      &::before {
        @apply bg-print-order-teal;
      }
    }
  }
}
</style>
